import OrderHistoryWidgetModal from "../OrderHistoryWidgetModal/OrderHistoryWidgetModal";
import './OrderHistoryWidget.css';
import { orderHistoryLatestServiceInit } from "../../../../store/OrderHistoryLatest/OrderHistoryLatestSlice";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { routePath } from "../../../../constants/Routes";
import { useTranslation } from 'react-i18next';
import { getLocalSessionData } from "../../../../utils/Authentication/handleUserSession";
import { LOCALSESSIONDATAKEYS } from "../../../../constants/AppConstants";

const OrderHistoryWidget = () => {
    const { t } = useTranslation(["translation"]);
    const deviceId = getLocalSessionData(LOCALSESSIONDATAKEYS?.DEVICE_ID)?.toLowerCase();
    const dispatch = useDispatch();
    useEffect( () => {
        dispatch( orderHistoryLatestServiceInit() );
        // eslint-disable-next-line
    } , [deviceId] )
    const {
        orderHistoryLatest_data
    } = useSelector( state => state.ROOTREDUCER_RTK.OrderHistoryLatestService );

    let latestOrderHistoryList = orderHistoryLatest_data?.supplyShippedHistory;

    return(
        <div className="widgetDetailsSection">
            { latestOrderHistoryList?.length > 0 && 
            <>
                <div className="orderHistoryWidgetContainer">
                    <OrderHistoryWidgetModal orderHistoryList={latestOrderHistoryList} />
                </div>
                <div className="showMoreOrderHistory">
                    <a href={routePath.ORDERS}>{t("ORDERHISTORY.WIDGET.SHOW_MORE")} </a>
                </div>
            </>
            }
            { ( latestOrderHistoryList === undefined || !latestOrderHistoryList?.length ) &&
                <div className="no_latest_orders"> 
                    {t("ORDERHISTORY.TABLE.NO_RECORDS_FOUND")}
                </div>
            }
        </div>
    )
}

export default OrderHistoryWidget;